var map = {
	"./decidim/avatar-multiuser.png": 77025,
	"./decidim/brands/google.svg": 66508,
	"./decidim/cc-badge.png": 95847,
	"./decidim/decidim-logo.svg": 49107,
	"./decidim/default-avatar.svg": 42759,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 75517,
	"./decidim/icons.svg": 69606,
	"./decidim/pattern.png": 52805,
	"./decidim/placeholder-card-g.svg": 57770,
	"./decidim/placeholder-card-l.svg": 49729,
	"./decidim/placeholder.jpg": 3424,
	"./decidim/remixicon.symbol.svg": 64850,
	"./decidim/vendor/leaflet/layers-2x.png": 74351,
	"./decidim/vendor/leaflet/layers.png": 73702,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 91099,
	"./decidim/vendor/leaflet/marker-icon.png": 80866,
	"./decidim/vendor/leaflet/marker-shadow.png": 21697,
	"./decidim/vendor/social-share-button/douban.svg": 27349,
	"./decidim/vendor/social-share-button/email.svg": 310,
	"./decidim/vendor/social-share-button/facebook.svg": 31454,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 56786,
	"./decidim/vendor/social-share-button/hacker_news.svg": 23222,
	"./decidim/vendor/social-share-button/linkedin.svg": 11980,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 7365,
	"./decidim/vendor/social-share-button/pinterest.svg": 25552,
	"./decidim/vendor/social-share-button/reddit.svg": 1226,
	"./decidim/vendor/social-share-button/telegram.svg": 41883,
	"./decidim/vendor/social-share-button/tumblr.svg": 73848,
	"./decidim/vendor/social-share-button/twitter.svg": 58811,
	"./decidim/vendor/social-share-button/vkontakte.svg": 98737,
	"./decidim/vendor/social-share-button/wechat.svg": 70180,
	"./decidim/vendor/social-share-button/whatsapp.svg": 11260,
	"./decidim/vendor/social-share-button/x.svg": 8926,
	"./decidim/vendor/social-share-button/xing.svg": 62170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96060;